export enum Priority {
  FAMILY = 'Family',
  WORK = 'Work',
  OTHERS = 'Others'
}

export enum Status {
  NON_WHATSAPP = 'Non WhatsApp Contact',
  WHATSAPP_CONTACT = 'WhatsApp Contact'
}
